import React from 'react';

import ValueReportComponentCard from './components/ValueReportComponentCard';
import { HouseTypeTabProps } from './ValueReport.type';
import { RouteComponentProps } from '@reach/router';
import TextEditor from './components/TextEditor';
import Icon from '~/components/Icon';

type Props = {
  /** Id for tests */
  datatestId: string;

  /**  Tab text for current tab content */
  label: string;

  /** data contains: {
    mainHeader: { text },
    subHeader: { text }
  }
   */
  data: HouseTypeTabProps;

  /** Callback function which call data updating in container state */
  onChange: (objectName?: string) => (value: $Object) => void;
} & RouteComponentProps;

const text = {
  title: 'Huistype',
  mainText: 'Koptekst',
  subText: 'Subtekst',
};

const HouseTypeTab = ({ onChange, data, datatestId }: Props) => {
  const { mainHeader, subHeader } = data;

  return (
    <ValueReportComponentCard
      datatestId={datatestId}
      title={text.title}
      cardIcon={<Icon name="home" />}
    >
      <TextEditor
        testName={'mainHeader'}
        text={mainHeader.text}
        title={text.mainText}
        onChange={value => onChange('mainHeader')({ text: value })}
        name="text"
        disabled={false}
      />
      <TextEditor
        testName={'subHeader'}
        text={subHeader.text}
        title={text.subText}
        onChange={value => onChange('subHeader')({ text: value })}
        name="text"
        disabled={false}
      />
    </ValueReportComponentCard>
  );
};

export default HouseTypeTab;
